// Modal functionality for YouTube videos
document.addEventListener("DOMContentLoaded", () => {
  // Game video IDs - replace with actual YouTube video IDs for each game
  const gameVideos = {
    paintdemonium: "x91MPoITQ3I" // Example video ID for Paintdemonium (replace with actual)
    // Add more game video IDs as needed
  };
  const modal = document.getElementById("video-modal");
  const iframe = document.getElementById("youtube-iframe");
  const closeBtn = document.querySelector(".close-modal");
  const gameButtons = document.querySelectorAll(".game-video-btn");

  // Open modal with the correct video based on the game
  gameButtons.forEach(button => {
    button.addEventListener("click", e => {
      e.preventDefault();
      const gameId = button.getAttribute("data-game");
      const videoId = gameVideos[gameId] || "dQw4w9WgXcQ"; // Default video if not found

      // Set the YouTube embed URL with autoplay
      iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=0`;

      // Show the modal
      modal.style.display = "flex";

      // Add class to body to prevent scrolling
      document.body.style.overflow = "hidden";
    });
  });

  // Close modal when clicking the close button
  closeBtn.addEventListener("click", closeModal);

  // Close modal when clicking outside the modal content
  window.addEventListener("click", e => {
    if (e.target === modal) {
      closeModal();
    }
  });

  // Close modal when pressing ESC key
  window.addEventListener("keydown", e => {
    if (e.key === "Escape" && modal.style.display === "flex") {
      closeModal();
    }
  });

  // Function to close the modal
  function closeModal() {
    modal.style.display = "none";
    iframe.src = ""; // Stop video playback
    document.body.style.overflow = ""; // Re-enable scrolling
  }
});